<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="12"
        >
          <title-notification-text />
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <content-notifications-text />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <s-date-notification-card />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <e-date-notification-card />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <categories-notifications-card />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <products-notifications-card />
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <status-notifications-card />
        </b-col>
      </b-row>
    </b-card>
    <b-row>
      <b-col>
        <notifications-image-card />
      </b-col>
    </b-row>
    <b-button
      variant="primary"
      :disabled="itemData.submitStatus"
      @click="submitForm"
    >
      Kaydet
    </b-button>
  </div>
</template>

<script>
import {
  BCard, BCol, BRow, BButton,

} from 'bootstrap-vue'
import TitleNotificationText from '@/views/Notifications/elements/TitleText.vue'
import ContentNotificationsText from '@/views/Notifications/elements/ContentText.vue'
import SDateNotificationCard from '@/views/Notifications/elements/sDateCard.vue'
import EDateNotificationCard from '@/views/Notifications/elements/eDateCard.vue'
import CategoriesNotificationsCard from '@/views/Notifications/elements/CategoriesCard.vue'
import ProductsNotificationsCard from '@/views/Notifications/elements/ProductsCard.vue'
import StatusNotificationsCard from '@/views/Notifications/elements/StatusCard.vue'
import NotificationsImageCard from '@/views/Notifications/elements/ImageCard.vue'

export default {
  name: 'ItemForm',
  components: {
    NotificationsImageCard,
    StatusNotificationsCard,
    ProductsNotificationsCard,
    CategoriesNotificationsCard,
    EDateNotificationCard,
    SDateNotificationCard,
    ContentNotificationsText,
    TitleNotificationText,
    BCard,
    BRow,
    BCol,
    BButton,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      mediaType: 'image',
      cropperSettings: {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      },
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['notifications/dataItem']
    },
  },
  mounted() {
    this.itemData.submitStatus = false
  },
}
</script>
